module.exports = __webpack_public_path__ + "images/c0fe6a954a225ab2dffd3598daf88fa06857d36bdce92c9abc4809a7c7e3f7dc.svg";